import React from 'react'
import "./Banner.css"
const Banner = ( props ) => {
    return (
        <h1 className={`banner__text ${props.size}`}>
            {props.children}
        </h1>
    )
}

export default Banner
